import { gql } from '@apollo/client';

export const GET_EMPLOYEES_LIST = gql`
  query GetEmployeesList {
    getEmployeesList {
      _id
      firstname
      lastname
    }
  }
`;

export const GET_EMP_EDIT_HISTORY = gql`
  query GetEditHistory($empid: String!, $page: Int, $limit: Int) {
    GetEditHistory(empid: $empid, page: $page, limit: $limit) {
      history {
        id
        userName
        action
        EditStatus
        changeTime
        empid
      }
      totalCount
    }
  }
`;



export const GET_EMPLOYEE_DETAILS = gql`
query {

  EmployeeDetail {
    response{
    id
    EmpID
    role
    createdDate
    firstname
    lastname
    token
    designation
    department
    salaryCTC
    reportingManager
    signedIn
    employeestatus
    gender
    clients
    dob
    image
    maritalStatus
    bloodGroup
    currentAddress
    permanentAddress
    mobile
    alternativeNumber
    personalEmail
    email
    adharNumber
    PanNumber
    BankAccountNo
    BankName
    IFCcode
    Branch
    PfNo
    UAN
    EsiNo
    DateOfJoining
    EmploymentType
    shiftInTime
shiftOutTime
    ProbationStatus
    Experience {
      years
      months
    }
    WorkType
    HealthInsuranceNo
    familyMembers {
      name
      relationship
      dob
      age
      dependent
    }
    emergencyContacts {
      name
      relationship
      phoneNumber
    }
    education {
      educationLevel
      college
      university
      from
      to
      degree
      fieldOfStudy
      typeOfStudy
    }
    client {
      NameOfClient
      processes
      role
      SlotNo
    }
    teamsReportIngManager {
      reportingManagerName
      reportingManagerType
      reportingManagerDepartment
      reportingManagerDesignation
    }
    teamsReportDirect {
      DirectReportName
      DirectReportType
      DirectReportDepartment
      DirectReportDesignation
    }
    workHistory {
      department
      designation
      clientHandled
      processHandled
     
      from
      to
    }
  }
}
}
`

export const EDIT_WORKHISTORY = gql`
mutation EditemployeeDetail($input:EditEmployeeInputType!)
{
EditemployeeDetail(input:$input)
{
  status
  message
}
}
`

export const CREATE_PROFILE_ATTACHMENTA = gql`
 mutation createProfileAttachment($input:AttachemntsInputType)
 { 
    createProfileAttachment(input:$input){
       status
       
    }
 }
 `
export const INSERT_ATTACHMENT = gql`
  mutation insertAttachment($id: String!, $data: [AttachemntsInputType]!) {
    insertAttachment(id: $id, input: $data) {
      status
      message
    }
  }
`;

export const INSERT_CLIENT_ATTACHMENT = gql`
  mutation insertClientAttachment($id: String!, $data: [AttachemntsClientInputType]!) {
    insertClientAttachment(id: $id, input: $data) {
      status
      message
    }
  }
`;

export const SINGLE_USER = gql`
  query SingleEmployee($id: String!) {  
    SingleEmployee(ID: $id) {
      status
      message
      count
      response{
    id
    EmpID
    firstname
    lastname
    salaryCTC
    createdTime
    designation
    department
    reportingManager
    image
    role
    clients
    employeestatus
    reportingTo
    signedIn
    gender
    dob
     personalEmail
    maritalStatus
    bloodGroup
    currentAddress
    permanentAddress
   workNote
  clientNote
  teamNote
  EducationNote
  documentNote
  familyNote
    alternativeNumber
    mobile
    email
      adharNumber
      PanNumber
      BankAccountNo
      BankName
      IFCcode
      Branch
      PfNo
      UAN
      EsiNo
      image
      DateOfJoining
        employmentStatus
  resignationStatus
  noticePeriod
  resignationDate
  lastWorkingDay
  RehireEligibility
    EmploymentType
    shiftInTime
shiftOutTime
    ProbationStatus
    probationPeriod
    processSplization
    additionalRoles
    reportingTo
      HealthInsuranceNo
    Experience {
      years
      months
    }
    WorkType
    HealthInsuranceNo
    familyMembers {
      name
      relationship
      dob
      age
      dependent
    }
       menu {
        name
        status
        mainId
        Subfields {
        displayName
          name
          status
          subId
        }
      }
    emergencyContacts {
      name
      relationship
      phoneNumber
    }
    education {
      educationLevel
      college
      university
      from
      to
      degree
      current
      fieldOfStudy
      typeOfStudy
    }
    client {
      NameOfClient
      processes
      role
      SlotNo
      confidentialAcess
    }
    teamsReportIngManager {
      reportingManagerName
      reportingManagerType
      reportingManagerDepartment
      reportingManagerDesignation
      reportingId
    }
    teamsReportDirect {
      DirectReportName
      DirectReportType
      DirectReportDepartment
      DirectReportDesignation
      reportingId
    }
    workHistory {
      department
      designation
      clientHandled
      processHandled
      shiftTimings
      from
      to
    }
    EditEmployee {
      id
    userName
    EditStatus
    action
    changeTime
      }
    leavesSettings {
          year
          department
          casualLeaves
          medicalLeave
          CarryforwardLeaves
          carryFlag
          Key
        }
    emailSettings{
      email
      password
      status
    }      
    sharedemailSettings{
      email
      status
    }
    salesEmailSettings{
      email
      salesEmailId
      status
    }
    personalOutlookEnabled
  }
}
  }
`;

export const GET_EMPLOYEES = gql`
  query {
    EmployeesDetails {
      id
      firstName
      lastName
      middleName
      designation
       salaryCTC
      department
      reportingManager
      email
      signIn
      gender
      dateOfBirth
      maritalStatus
      officialEmailId
      personalEmailId
      phoneNumber
      alterNatePhone
      clients
      currentAddress
      permanentAddress
      AadharNumber
      PanNumber
      BankAccount
      BranchName
      IFSCcode
      BankName
      PFnumber
      UANnumber
      image
      ESICnumber
       workNote
  clientNote
  teamNote
  EducationNote
  documentNote
  familyNote
      HealthInsuranceNumber
      educationDetails{
       collegeName
       courseName
       branchName
       onType
       duration
       universityName
      }
      familyRelationShip{
       name
       dateOfBirth
       relationShip
       age
       dependent
       phoneNumber
      }
      reportingManagerDetails{
      name
      type
      department
      designation
      }
      clientDetails{
      clientName
      department
      process
      role
      slotNo
      }
    attachemnts{
  userId
emailId
data
filename
mimetype
addDate
updateDate
status
}
    }
  }
`;


export const REMOVE_ATTACHMENT = gql`
  mutation removeAttachment($id: String!, $userId: String! ,$input:AttachemntsInputType! ) {
    removeAttachment(id: $id, attachmentId: $userId ,input:$input ) {
       status
       message
}
  }
`;
export const REMOVE_CLIENT_ATTACHMENT = gql`
  mutation removeClientAttachment($id: String!, $userId: String! ,$input:AttachemntsInputType! ) {
    removeClientAttachment(id: $id, attachmentId: $userId ,input:$input ) {
       status
       message
}
  }
`;
export const UPDATE_EMPLOYEE = gql`
  mutation updateEmploye($id:String ,$input:UpdateEmployeeInput){
 
 UpdateEmploye( id:$id ,input: $input) {
    status
    message
}
}`

// Fetch all modified attachments by email ID
export const FETCH_MODIFIED_ATTACHMENTS_BY_EMAIL = gql`
mutation fetchModifiedAttachmentsByEmail($emailId: String!) {
  getAllModifiedAttachmentsByID(emailId: $emailId) {
    id
    filename
    data
    mimetype
    addDate
    updateDate
    status
  }
}
`;

// Update attachment
export const MODIFY_ATTACHMENT_DETAILS = gql`
  mutation modifyAttachmentDetails( $id:String
    $input:AttachemntsInputType
  ) {
    modifyAttachmentDetails(
    attachmentid:$id
     input:$input
    ) {
      id
      filename
      data
      mimetype
      addDate
      updateDate
      status
     
    }
  }
`;

export const MODIFY_CLIENT_ATTACHMENT_DETAILS = gql`
  mutation modifyAttachmentDetails($id: String, $input: AttachemntsInputType!) {
    ClientmodifyAttachmentDetails(attachmentid: $id, input: $input) {
      id
      filename
      data
      mimetype
      addDate
      updateDate
      status
    }
  }
`;

export const GET_ALL_PROFILE_ATTACHMENTS = gql`
  query GetAllProfileHistoryAttachments($userid: String!, $empid: String!) {
    GetAllProfileistoryAttachmenta(usersid: $userid, empid: $empid) {
      userId
      emailId
      data
      filename
      mimetype
      status
      addDate
      updateDate
    }
  }
`;

export const ALL_ATTACHMENTS = gql`
  query FetchEmployeeAttachments($ID: String) {
  FetchAttachments(id: $ID) {
    response {
      attachemnts {
        id
        filename
        data
        userId
        emailId
        mimetype
        addDate
        updateDate
        status
        userName
        attachmetHistory{
        userId
       emailId
       userName
        replacedFile
       data
      filename
    mimetype
     deleteDate
    addDate
    updateDate
    status
        }
      }
    }
  }
}

`;

export const ALL_CLIENT_ATTACHMENTS = gql`
  query FetchClientAttachments($ID: String) {
  FetchClientAttachments(id: $ID) {
    response {
      attachemnts {
        id
        filename
        data
        userId
        emailId
        mimetype
        addDate
        updateDate
        status
        userName
        attachmetHistory{
        userId
       emailId
       userName
        replacedFile
       data
      filename
    mimetype
     deleteDate
    addDate
    updateDate
    status
        }
      }
    }
  }
}

`;




export const ADD_EMPLOYEES = gql`
  mutation createEmployee($input: CreateEmployeeInput) {
    createEmploye(input: $input) {
      status
      message
      response{
         id
         EmpID
  role
  firstname
  lastname
  designation
  department
  reportingManager
  signedIn
  gender
  dob
  status
  token
  employeestatus
  maritalStatus
  bloodGroup
  currentAddress
  permanentAddress
  mobile
  alternativeNumber
  personalEmail
  email
  processSplization
  additionalRoles
  adharNumber
  PanNumber
  BankAccountNo
  BankName
  reportingTo
  clients
  DateOfJoining
  
      
      }
    }
  }
`;
export const DELETE_ATTACHMENTS = gql`
mutation ($id: String!
$userId: String!
  $updateDate: String!) {
    deleteAttachments(id: $id
    userId: $userId
      updateDate: $updateDate) {
      emailId
      userId
      data
      status
      filename
      mimetype
      addDate
      updateDate
    }
  }
`;
export const UPDATE_ATTACHMENTS = gql`
mutation (
  $id: String!
  $data: String!
  $filename: String!
  $mimetype: String!
  $userId: String!
  $updateDate: String!) {
    updateAttachments(
    id: $id
    data: $data
    filename: $filename
    mimetype: $mimetype
    userId: $userId
    updateDate: $updateDate) {
      emailId
      userId
      data
      filename
      mimetype
      addDate
      updateDate
    }
  }
`;
export const CREATE_ATTACHEMNTS = gql`
mutation (
  $userId: String!
  $emailId: String!

  $data: String!
  $filename: String!
  $mimetype: String!
  $addDate: String!
  $updateDate: String!
  $status: Boolean!) {
    createAttachments(
      userId: $userId
      emailId: $emailId
      data: $data
      filename: $filename
      mimetype: $mimetype
      addDate: $addDate
      updateDate: $updateDate
      status: $status) {
        id
        userId
        emailId
        data
        filename
        mimetype
        addDate
        updateDate
        status
      }
    }
  `;

export const GET_ALLATTACHMENTS_BY_ID = gql`
  mutation ($emailId: String!) {
    getAllAttachmentsByID(emailId: $emailId) {
      id
      userId
      emailId
      data
      filename
      mimetype
      addDate
      updateDate
      status
      attachmentHistory{
      userId
      emailId
      filename
      mimetype
      addDate
      updateDate
      status}
    }
  }
`;
export const GET_ALL_MODIFIED_ATTACHMENTS_BY_ID = gql`
mutation ($emailId: String!) {
  getAllModifiedAttachmentsByID(emailId: $emailId) {
    id
    userId
    emailId
    data
    filename
    mimetype
    addDate
    updateDate
    status
  }
}
`;

export const GET_ALLATTACHMENT_HISTORY_BY_ID = gql`
mutation ($userId: String!, $emailId: String!) {
  getAllAttachmentHistoryByID(userId: $userId, emailId: $emailId) {
    id
    userId
    emailId
    data
    filename
    mimetype
    addDate
    updateDate
    status
  }
}
`;


